.vc-voice-download {
    width: 24px;
    height: 24px;
    color: var(--interactive-normal);
    margin-left: 12px;
    cursor: pointer;
    position: relative;
}

.vc-voice-download:hover {
    color: var(--interactive-active);
}
